function Filter() {
  return function(num) {
    if (num === undefined || num === null || num === false) return 0;

    return num.toFixed(2);
  };
}

Filter.$inject = [];

export default Filter;



// WEBPACK FOOTER //
// ./src/filters/decimalFilter.js